import { useMemo } from "react";

import type { KnownPaths } from "./TemplateEditor.utils";
import type { TemplateVariablesResponse } from "./TemplatesForm.types";

// Whitelist допустимых путей переменных. Считается раз на загрузку variables —
// сравниваем case-insensitive (params/properties NFC-normalized на бэке).
export const useKnownPaths = (
  variables: TemplateVariablesResponse | null,
): KnownPaths | null =>
  useMemo(() => {
    if (!variables) return null;
    const scalars = new Set<string>();
    for (const list of Object.values(variables.scalars)) {
      for (const v of list) scalars.add(v.key.toLocaleLowerCase());
    }
    const prefixes = new Set<string>();
    for (const c of variables.collections) {
      prefixes.add(c.prefix.toLocaleLowerCase());
    }
    return { scalars, prefixes };
  }, [variables]);
